export default __webpack_public_path__ + "static/media/tower.4466b6b1.png";